// @ts-nocheck
// TODO: tighten types after migration
import React from "react";
import Header from "../Header";
import Footer from "../footer";
import AdminHome from "./AdminHome";

export default function Admin() {
    return (
        <>
            <link rel="stylesheet" href="https://cdn-uicons.flaticon.com/3.0.0/uicons-bold-rounded/css/uicons-bold-rounded.css" />
            {/* Icon font for admin sidenav toggle */}
            <link rel="stylesheet" href="https://cdn-uicons.flaticon.com/3.0.0/uicons-solid-rounded/css/uicons-solid-rounded.css" />
            <Header />
            <AdminHome />
            <Footer />
        </>
    );
}


